import React from 'react';
import { motion, HTMLMotionProps } from 'framer-motion';
interface CardProps extends HTMLMotionProps<'div'> {
  children: React.ReactNode;
}
export function Card({
  children,
  className = '',
  ...props
}: CardProps) {
  return <motion.div initial={{
    opacity: 0,
    y: 20
  }} animate={{
    opacity: 1,
    y: 0
  }} exit={{
    opacity: 0,
    y: -20
  }} className={`bg-white rounded-2xl shadow-xl border border-slate-100 overflow-hidden ${className}`} {...props} data-id="element-228">
      {children}
    </motion.div>;
}